import Notification from './Notification'

export default Notification



// WEBPACK FOOTER //
// ./src/components/notification/index.js